import { render, staticRenderFns } from "./rightSidebarSectionInstance.vue?vue&type=template&id=353e3ab6"
import script from "./rightSidebarSectionInstance.vue?vue&type=script&lang=js"
export * from "./rightSidebarSectionInstance.vue?vue&type=script&lang=js"
import style0 from "./rightSidebarSectionInstance.vue?vue&type=style&index=0&id=353e3ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports